import React from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom'
import { Result, Button } from 'antd'

class NotAllowed extends React.Component {
    onClick = (e) => {
        this.props.history.push('/user/login')
    }

    componentDidMount() {
        const pathSnippets = this.props.location.pathname.split('/').filter(i => i)

        this.props.setPathSnippetsState(pathSnippets)
    }

    render() {
        return (
            <Result
                status="403"
                title="Denied"
                subTitle="Sorry, you are not authorized to access this page. Please log in or contact Administrator."
                extra={<Button type="primary" onClick={this.onClick}>Log in</Button>}
            />
        )
    }
}

NotAllowed.propTypes = {
    setPathSnippetsState: PropTypes.func
}

export default withRouter(NotAllowed)